import React, { useState } from "react";
import styles from "./styles/tweet.module.css";
import { useCurrentUser } from "../actions/auth";
import { getPublicImageURL } from "../_helpers/image";

const Tweet = ({ content }) => {
    const {
        isLoading: loadingMe,
        isSuccess: successMe,
        data: dataMe,
    } = useCurrentUser();

    const [hoveredName, setHoveredName] = useState(false);
    const [hoveredMoreOptions, setHoveredMoreOptions] = useState(false);
    const fallback_image =
        "https://api.dicebear.com/7.x/avataaars/svg?seed=John";

    const [isHovered, setIsHovered] = useState(false);
    const [isLiked, setIsLiked] = useState(false);
    const [isRetweeted, setIsRetweeted] = useState(false);
    const [isBookmarked, setIsBookmarked] = useState(false);
    const [likes, setLikes] = useState(1234);
    const [retweets, setRetweets] = useState(89);
    const [replies] = useState(56);
    const [views] = useState(12500);
    // Don't render until user data is loaded
    if (loadingMe || !successMe) {
        return <div className={styles.loading}>Loading...</div>;
    }

    const handleLike = (e) => {
        e.stopPropagation();
        setIsLiked(!isLiked);
        setLikes(isLiked ? likes - 1 : likes + 1);
    };

    const handleRetweet = (e) => {
        e.stopPropagation();
        setIsRetweeted(!isRetweeted);
        setRetweets(isRetweeted ? retweets - 1 : retweets + 1);
    };

    const handleBookmark = (e) => {
        e.stopPropagation();
        setIsBookmarked(!isBookmarked);
    };

    const formatNumber = (num) => {
        if (num >= 1000) {
            return (num / 1000).toFixed(1) + "K";
        }
        return num;
    };

    return (
        <div
            className={`${styles.tweet} ${isHovered ? styles.tweetHover : ""}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={styles.header}>
                <img
                    src={
                        dataMe.avatar
                            ? getPublicImageURL(dataMe.avatar)
                            : fallback_image
                    }
                    alt="Profile"
                    className={styles.avatar}
                />
                <div className={styles.content}>
                    <div className={styles.userInfo}>
                        <div className={styles.userDetails}>
                            <span className={styles.displayName}>
                                {dataMe.selected_org?.name || ""}
                                {/* Verified tick */}
                                <svg
                                    className={styles.verifiedIcon}
                                    viewBox="0 0 24 24"
                                    fill="#1d9bf0"
                                >
                                    <path d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81c-.66-1.31-1.91-2.19-3.34-2.19s-2.67.88-3.33 2.19c-1.4-.46-2.91-.2-3.92.81s-1.26 2.52-.8 3.91c-1.31.67-2.2 1.91-2.2 3.34s.89 2.67 2.2 3.34c-.46 1.39-.21 2.9.8 3.91s2.52 1.26 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.68-.88 3.34-2.19c1.39.45 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34zm-11.71 4.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77z" />
                                </svg>
                            </span>
                            <span className={styles.username}>
                                @
                                {dataMe.selected_org?.name
                                    ?.toLowerCase()
                                    .replace(/\s+/g, "") || ""}
                            </span>
                            <span className={styles.timestamp}>· 2h</span>
                        </div>
                        <button
                            className={styles.moreButton}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Grok icon */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width="100"
                                height="100"
                                viewBox="0 0 48 48"
                                className={styles.grokIcon}
                            >
                                <path d="M18.542 30.532l15.956-11.776c.783-.576 1.902-.354 2.274.545 1.962 4.728 1.084 10.411-2.819 14.315-3.903 3.901-9.333 4.756-14.299 2.808l-5.423 2.511c7.778 5.315 17.224 4 23.125-1.903 4.682-4.679 6.131-11.058 4.775-16.812l.011.011c-1.966-8.452.482-11.829 5.501-18.735C47.759 1.332 47.88 1.166 48 1l-6.602 6.599V7.577l-22.86 22.958M15.248 33.392c-5.582-5.329-4.619-13.579.142-18.339 3.521-3.522 9.294-4.958 14.331-2.847l5.412-2.497c-.974-.704-2.224-1.46-3.659-1.994-6.478-2.666-14.238-1.34-19.505 3.922C6.904 16.701 5.31 24.488 8.045 31.133c2.044 4.965-1.307 8.48-4.682 12.023C2.164 44.411.967 45.67 0 47l15.241-13.608"></path>
                            </svg>
                            {/* <svg
                                className={styles.grokIcon}
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                            </svg> */}
                            <svg
                                className={styles.icon}
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <circle cx="12" cy="5" r="2" />
                                <circle cx="12" cy="12" r="2" />
                                <circle cx="12" cy="19" r="2" />
                            </svg>
                        </button>
                    </div>
                    <div className={styles.tweetText}>{content?.content}</div>
                    <div className={styles.actions}>
                        <button
                            className={`${styles.actionButton} ${styles.replyButton}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <svg
                                className={styles.icon}
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M1.751 10c0-4.42 3.584-8 8.005-8h4.366c4.49 0 8.129 3.64 8.129 8.13 0 2.96-1.607 5.68-4.196 7.11l-8.054 4.46v-3.69h-.067c-4.49.1-8.183-3.51-8.183-8.01zm8.005-6c-3.317 0-6.005 2.69-6.005 6 0 3.37 2.77 6.08 6.138 6.01l.351-.01h1.761v2.3l5.087-2.81c1.951-1.08 3.163-3.13 3.163-5.36 0-3.39-2.744-6.13-6.129-6.13H9.756z" />
                            </svg>
                            <span>{replies}</span>
                        </button>
                        <button
                            className={`${styles.actionButton} ${
                                styles.retweetButton
                            } ${isRetweeted ? styles.retweeted : ""}`}
                            onClick={handleRetweet}
                        >
                            <svg
                                className={styles.icon}
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M4.5 3.88l4.432 4.14-1.364 1.46L5.5 7.55V16c0 1.1.896 2 2 2H13v2H7.5c-2.209 0-4-1.79-4-4V7.55L1.432 9.48.068 8.02 4.5 3.88zM16.5 6H11V4h5.5c2.209 0 4 1.79 4 4v8.45l2.068-1.93 1.364 1.46-4.432 4.14-4.432-4.14 1.364-1.46 2.068 1.93V8c0-1.1-.896-2-2-2z" />
                            </svg>
                            <span>{formatNumber(retweets)}</span>
                        </button>
                        <button
                            className={`${styles.actionButton} ${
                                styles.likeButton
                            } ${isLiked ? styles.liked : ""}`}
                            onClick={handleLike}
                        >
                            <svg
                                className={styles.icon}
                                viewBox="0 0 24 24"
                                fill={isLiked ? "currentColor" : "none"}
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path d="M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12z" />
                            </svg>
                            <span>{formatNumber(likes)}</span>
                        </button>
                        <button
                            className={`${styles.actionButton} ${styles.shareButton}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <svg
                                className={styles.icon}
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M8.75 21V3h2v18h-2zM18 21V8.5h2V21h-2zM4 21l.004-10h2L6 21H4zm9.248 0v-7h2v7h-2z" />
                            </svg>
                            <span>{formatNumber(views)}</span>
                        </button>
                        <button
                            className={`${styles.actionButton} ${
                                styles.shareButton
                            } ${isBookmarked ? styles.bookmarked : ""}`}
                            onClick={handleBookmark}
                        >
                            <svg
                                className={styles.icon}
                                viewBox="0 0 24 24"
                                fill={isBookmarked ? "currentColor" : "none"}
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path d="M4 4.5C4 3.12 5.119 2 6.5 2h11C18.881 2 20 3.12 20 4.5v18.44l-8-5.71-8 5.71V4.5z" />
                            </svg>
                        </button>
                        <button
                            className={`${styles.actionButton} ${styles.shareButton}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <svg
                                className={styles.icon}
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width="100"
                                height="100"
                                viewBox="0 0 48 48"
                            >
                                <path d="M 36 5 C 32.151772 5 29 8.1517752 29 12 C 29 12.585766 29.198543 13.109464 29.335938 13.654297 L 17.345703 19.652344 C 16.059118 18.073938 14.181503 17 12 17 C 8.1517722 17 5 20.151775 5 24 C 5 27.848225 8.1517722 31 12 31 C 14.181503 31 16.059118 29.926062 17.345703 28.347656 L 29.335938 34.345703 C 29.198543 34.890536 29 35.414234 29 36 C 29 39.848225 32.151772 43 36 43 C 39.848228 43 43 39.848225 43 36 C 43 32.151775 39.848228 29 36 29 C 33.818497 29 31.940882 30.073938 30.654297 31.652344 L 18.664062 25.654297 C 18.801457 25.109464 19 24.585766 19 24 C 19 23.414234 18.801457 22.890536 18.664062 22.345703 L 30.654297 16.347656 C 31.940882 17.926062 33.818497 19 36 19 C 39.848228 19 43 15.848225 43 12 C 43 8.1517752 39.848228 5 36 5 z M 36 8 C 38.226909 8 40 9.7730927 40 12 C 40 14.226907 38.226909 16 36 16 C 33.773091 16 32 14.226907 32 12 C 32 9.7730927 33.773091 8 36 8 z M 12 20 C 14.226909 20 16 21.773093 16 24 C 16 26.226907 14.226909 28 12 28 C 9.7730915 28 8 26.226907 8 24 C 8 21.773093 9.7730915 20 12 20 z M 36 32 C 38.226909 32 40 33.773093 40 36 C 40 38.226907 38.226909 40 36 40 C 33.773091 40 32 38.226907 32 36 C 32 33.773093 33.773091 32 36 32 z"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tweet;
